var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcExit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.51562 3.51472C4.62993 2.40041 5.9528 1.5165 7.40871 0.913445C8.86461 0.310389 10.425 -1.67277e-07 12.0009 0C13.5768 1.67277e-07 15.1372 0.31039 16.5931 0.913446C18.049 1.5165 19.3719 2.40042 20.4862 3.51472C21.6005 4.62902 22.4844 5.95189 23.0875 7.4078C23.6905 8.86371 24.0009 10.4241 24.0009 12C24.0009 13.5759 23.6905 15.1363 23.0875 16.5922C22.4844 18.0481 21.6005 19.371 20.4862 20.4853L3.51562 3.51472Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.21177 18.7882C8.96081 22.5373 15.0392 22.5373 18.7882 18.7882C22.5373 15.0392 22.5373 8.96081 18.7882 5.21177C15.0392 1.46274 8.96081 1.46274 5.21177 5.21177C1.46274 8.96081 1.46274 15.0392 5.21177 18.7882ZM3.51472 20.4853C8.20101 25.1716 15.799 25.1716 20.4853 20.4853C25.1716 15.799 25.1716 8.20101 20.4853 3.51472C15.799 -1.17157 8.20101 -1.17157 3.51472 3.51472C-1.17157 8.20101 -1.17157 15.799 3.51472 20.4853Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6767 8.32314C16.1453 8.79177 16.1453 9.55156 15.6767 10.0202L10.0198 15.677C9.55117 16.1457 8.79137 16.1457 8.32274 15.677C7.85411 15.2084 7.85411 14.4486 8.32274 13.98L13.9796 8.32314C14.4482 7.85451 15.208 7.85451 15.6767 8.32314Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6749 15.6771C15.2063 16.1458 14.4465 16.1458 13.9779 15.6771L8.321 10.0203C7.85237 9.55166 7.85237 8.79186 8.321 8.32323C8.78963 7.8546 9.54943 7.8546 10.0181 8.32323L15.6749 13.9801C16.1435 14.4487 16.1435 15.2085 15.6749 15.6771Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExit);
export default __webpack_public_path__ + "static/media/ic-exit.c62eb947f87136bd26511363f3f6b0a7.svg";
export { ForwardRef as ReactComponent };